<template>
  <form class="newJOB column" @submit="save()" onsubmit="return false">
    <div class="title grid-12">
      Nova
      <strong>Solicitação</strong>
    </div>

    <div class="data column label">
      <div class="sla">Dados do Job</div>
      <div class="row column-s wrap">
        <div class="grid-2-g grid-3-m grid-12 column">
          Cliente
          <br />
          <input type="text" class="readonly" :value="user.nome_cliente" readonly />
        </div>
        <!-- <div class="grid-2-g grid-4-m grid-12-s column">
          Urgência
          <br />
          <select v-model="job.urgencia_atendimento" required>
            <option value>Selecione uma opção</option>
            <option value="imediato">Atendimento Imediato</option>
            <option value="agendado">Atendimento Agendado</option>
          </select>
        </div> -->
        <div class="grid-2-g grid-3-m grid-12 column" v-if="job.urgencia_atendimento === 'agendado'">
          Agendamento
          <br />
          <input type="datetime-local" v-model="job.dh_agendamento_cliente"
            @change="updateServiceType({ nome: '', tipo: null })" required />
        </div>

        <template v-if="user.categoriza_job">
          <ServiceType :text="serviceType" :client="user.id_cliente" :css="'grid-2-g grid-3-m grid-12-s'"
            @value="(item) => updateServiceType(item)" required />
          <Diary v-if="showDiary" :job="job" :css="'grid-12'" @value="(item) => updateDiary(item)" />
          <div class="column grid-2-g grid-3-m grid-12-s" v-if="showFolgaObrigatoria">
            <label>Intervalo de Almoço <i>(HH:MM)</i></label>
            <input v-model="job.folga_obrigatoria" v-mask="'##:##'" placeholder="Intervalo de Almoço (HH:MM)"
              required />
          </div>

          <ClienteCliente :css="'grid-2-g grid-3-m grid-12-s column'" :cliente="user.id_cliente"
            :atual="job.id_cliente_cliente" @value="vincularClienteCliente" />
          <AgregateClient :key="'agregado' + chaveAgregado" :css="'grid-2-g grid-12-s grid-3-m column'"
            :client="user.id_cliente" @value="vincularAgregado" />
          <small v-if="job.id_cliente_cliente || job.id_agregado_cliente" class="grid-12 exclusao">
            Cliente do cliente e agregado do cliente não se combinam: escolher um limpa o outro.
          </small>
        </template>

        <div class="grid-2 grid-12-s column">
          Chamado Cliente
          <br />
          <input type="text" v-model="job.codigo_chamado_cliente" @change="verify_client_cod()" />
        </div>

        <div class="grid-6-g grid-12 column" v-if="job.codigo_duplicado">
          Motivo código do cliente duplicado
          <br />
          <input type="text" v-model="job.motivo_codigo_duplicado" required />
        </div>
      </div>
    </div>

    <div class="data column label">
      <div class="sla">
        Localização &nbsp;
        <Button layout="blue-m" type="button" @click="useMyAdress()">
          <i class="fa fa-map-marker"></i> Usar meu endereço
        </Button>
      </div>
      <div class="grid-1-g grid-12 column">
        <div class="row">
          CEP <a style="margin-left:6px" class="cp" href="https://buscacepinter.correios.com.br/app/endereco/index.php"
            target="_blank">
            (CORREIOS)</a>
        </div>
        <input style="margin-top: -22px;" type="text" v-model="job.cep" @input="cep" v-mask="'##.###-###'" required />
      </div>
      <div class="row wp">
        <div class="grid-2-g grid-12 column">
          Logradouro
          <br />
          <input type="text" :class="logradouro ? 'readonly' : ''" :readonly="logradouro" v-model="job.logradouro" />
        </div>
        <div class="grid-2-g grid-12 column">
          Número
          <br />
          <input type="number" v-model="job.numero" required />
        </div>
        <div class="grid-2-g grid-12 column">
          Cidade
          <br />
          <input type="text" class="readonly" :readonly="cidade" v-model="job.cidade" />
        </div>
        <div class="grid-2-g grid-12 column">
          Bairro
          <br />
          <input type="text" :class="bairro ? 'readonly' : ''" :readonly="bairro" v-model="job.bairro" />
        </div>
        <div class="grid-2-g grid-12 column">
          Estado
          <br />
          <input type="text" class="readonly" :readonly="estado" v-model="job.estado" />
        </div>
        <div class="grid-2-g grid-12 column">
          Complemento
          <br />
          <input type="text" v-model="job.complemento" />
        </div>
        <div class="grid-4-g grid-12 column">
          Nome no local de atendimento
          <br />
          <input type="text" v-model="job.nome_local_atendimento" required />
        </div>
      </div>
    </div>

    <div class="data column label">
      <div class="sla">Dados do contato</div>
      <div class="row column-s wrap">
        <div class="grid-3-g grid-5-m grid-12 column">
          Nome
          <br />
          <input type="text" v-model="job.nome_contato" />
        </div>
        <div class="grid-3-g grid-5-m grid-12 column">
          Email
          <br />
          <input type="email" v-model="job.email_contato" />
        </div>
        <div class="grid-3-g grid-5-m grid-12 column">
          Telefone
          <br />
          <input type="text" v-model="job.celular_contato" v-mask="'(##) #####-####'" />
        </div>

      </div>
    </div>

    <div class="grid-12 column label">
      <div class="sla">Descrição do problema</div>
      <div class="row column-s">
        <div class="grid-6 grid-12-s column label">
          <br />
          <label>
            Descrição Problema
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Descreva em detalhes o seu problema. Não informe aqui dados sensíveis.
              </div>
            </i>
          </label>
          <textarea class="textarea" v-model="job.problema" required></textarea>
        </div>
        <div class="grid-6 grid-12-s column label">
          <br />
          <label>
            Dados Sensíveis
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Informe aqui dados sensíveis como contatos, endereços, senhas, nomes,
                telefones, etc.
              </div>
            </i>
          </label>
          <textarea class="textarea" v-model="job.dado_sensivel"></textarea>
        </div>
      </div>
    </div>

    <div class="buttons-2 row column-s align-center">
      <div class="grid-4 grid-12-s hide-s">
        <Button type="button" layout="white-m-gray" @click="router.back()">
          <i class="fa fa-arrow-left"></i> Voltar
        </Button>
      </div>
      <div v-if="job.id_tipo_servico && job.cep && job.numero && job.nome_local_atendimento && job.problema" class="row justify-end align-center buttons grid-12-s grid-8">
        <Button class="save grid-12-s" layout="green-go" :loader="send" type="submit">ENVIAR SOLICITAÇÃO</Button>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
import { mapActions, mapGetters, mapMutations } from "vuex";
import Button from "@/components/Button";
import AgregateClient from "@/components/select/AgregateClient.vue";
import ClienteCliente from "@/components/select/ClienteCliente.vue";
import ServiceType from "@/components/select/ServiceType.vue";
import Diary from "@/components/Diary.vue";
import Router from "@/router";

let nextday = new Date();
nextday.setDate(nextday.getDate() + 1);

var jobInit = {
  id_projeto: "",
  urgencia_atendimento: "agendado",
  dh_agendamento_cliente: new Date(nextday).toISOString().slice(0, 10) + "T" + nextday.getHours() + ":" + nextday.getMinutes(),
  cep: "",
  bairro: "",
  celular_contato: null,
  cidade: "",
  codigo_chamado_cliente: null,
  codigo_duplicado: false,
  codigo_venda: null,
  complemento: null,
  email_contato: null,
  estado: "",
  forma_atendimento: null,
  id_cliente: null,
  latitude: null,
  longitude: null,
  logradouro: "",
  motivo_codigo_duplicado: null,
  nome_contato: null,
  nome_local_atendimento: null,
  numero: "",
  problema: "",
  dado_sensivel: null,
  id_cliente_cliente: null,
  id_agregado_cliente: null, // explícito para a nota de exclusão mútua reagir; o backend trata nulo como o de id_cliente_cliente
  folga_obrigatoria: "01:00",
  id_tipo_servico: null,
  dias_cancelados_agenda: [],
}

export default {
  name: "NewJob",
  components: { Button, AgregateClient, ClienteCliente, ServiceType, Diary },
  data() {
    return {
      showFolgaObrigatoria: false,
      serviceType: "",
      showDiary: false,
      send: false,
      logradouro: true,
      bairro: true,
      estado: true,
      cidade: true,
      job: { ...jobInit },
      router: Router,
      chaveAgregado: 0, // remonta o seletor de agregado ao limpá-lo, pois ele não tem como ser limpo por fora
    };
  },
  methods: {
    ...mapActions("client", [
      "SERVICES_TYPE_LIST",
      "CLIENT_COD_VERIFY",
      "CREATE_JOB_ALOCACAO",
      "CREATE_JOB_AVULSO",
      "CREATE_JOB",
    ]),
    ...mapActions("user", ["LOAD_PERFIL"]),
    ...mapActions("general", ["LOAD_CEP"]),
    ...mapMutations("general", ["SET_STATUS"]),
    // As rotas de abertura recusam cliente do cliente e agregado do cliente juntos: escolher um limpa o outro.
    vincularClienteCliente(id) {
      this.job.id_cliente_cliente = id;
      if (id && this.job.id_agregado_cliente) {
        this.job.id_agregado_cliente = null;
        this.chaveAgregado++;
      }
    },
    vincularAgregado(item) {
      this.job.id_agregado_cliente = item.id;
      if (item.id) this.job.id_cliente_cliente = null;
    },
    updateServiceType(item) {
      this.serviceType = item.nome
      document.getElementById('serviceType').value = ""
      this.showFolgaObrigatoria = item.requer_folga_obrigatoria || false;
      this.job.id_tipo_servico = item.id;
      this.showDiary = item.tipo == "alocacao" ? true : false;
      this.job.forma_atendimento = item.tipo;
      this.$forceUpdate();
    },
    updateDiary(item) {
      this.job.dias_cancelados_agenda = []
      if (item.del) this.job.dias_cancelados_agenda.push(item.dt_atendimento);
      else
        this.job.dias_cancelados_agenda = this.job.dias_cancelados_agenda.filter(
          (day) => day != item.dt_atendimento
        );
    },
    verify_client_cod() {
      if (this.job.codigo_chamado_cliente)
        this.CLIENT_COD_VERIFY({
          id_client: this.user.id_cliente,
          id_call: this.job.codigo_chamado_cliente,
        }).then(
          (r) => (this.job.codigo_duplicado = r.data && r.data.length ? true : false)
        );
    },
    cep() {
      if (this.job.cep.length > 9) {
        this.logradouro = true;
        this.bairro = true;
        this.estado = true;
        this.cidade = true;
        this.job.logradouro = ''
        this.job.bairro = ''
        this.job.cidade = ''
        this.job.estado = ''
        this.LOAD_CEP(this.job.cep.replace(".", "").replace("-", "")).then((r) => {
          if (r.logradouro) {
            this.job.logradouro = r.logradouro;
            this.job.bairro = r.bairro;
            this.job.cidade = r.localidade;
            this.job.estado = r.uf;
          }

          if (!r.logradouro && r.uf && r.estado) {
            this.SET_STATUS({ text: "O CEP informado resultou um endereço incompleto. Informe o endereço manualmente.", color: "orange" })
            this.job.bairro = r.bairro;
            this.job.cidade = r.localidade;
            this.job.estado = r.uf;
            this.logradouro = false;
            this.bairro = false;
          }

          //15520000
          if (!r.logradouro && !r.uf && !r.estado)
            this.SET_STATUS({
              text: "CEP inválido, clique no link dos Correios para encontrar o CEP correto através do endereço.",
              color: "red",
            });

          /* if (r && (r.logradouro || r.localidade)) {
            this.job = {
              ...this.job,
              logradouro: r.logradouro,
              bairro: r.bairro,
              cidade: r.localidade,
              estado: r.uf,
            };
            if (r && !r.logradouro) {
              this.logradouro = false;
              this.bairro = false;
            } else {
              this.logradouro = true;
              this.bairro = true;
            }
          }  */
        });
      }
    },
    save() {
      if (
        this.job.cep &&
        this.job.numero &&
        this.job.logradouro &&
        this.job.bairro &&
        this.job.cidade &&
        this.job.estado
      ) {
        this.send = true;
        this.job.id_cliente = this.user.id_cliente;
        this.job.cep = this.job.cep.replace(".", "").replace("-", "");
        this.job.dh_agendamento_cliente = this.job.dh_agendamento_cliente
          ? this.job.dh_agendamento_cliente.replace("T", " ")
          : "";
        this.job.celular_contato = this.job.celular_contato
          ? this.job.celular_contato
            .replace("(", "")
            .replace(")", "")
            .replace("-", "")
            .replace(/ /g, "")
          : null;
        this.geo();
      } else {
        this.SET_STATUS({
          text: "Endereço inválido",
          color: "red",
        });
      }
    },
    useMyAdress() {
      this.job = {
        ...this.job,
        cep: this.perfil.cep,
        logradouro: this.perfil.logradouro,
        bairro: this.perfil.bairro,
        cidade: this.perfil.cidade,
        estado: this.perfil.estado,
        numero: this.perfil.numero,
      };
    },
    createJob() {
      let url = "CREATE_JOB";

      if (this.user.categoriza_job)
        url =
          this.job.forma_atendimento == "alocacao"
            ? "CREATE_JOB_ALOCACAO"
            : "CREATE_JOB_AVULSO";

      this[url](this.job)
        .then((r) => {
          if (r.status == 201 || r.status == 200) {
            this.showDiary = false;
            this.showFolgaObrigatoria = false;
            this.job = { ...jobInit };
            this.job.dh_agendamento_cliente =
              new Date(nextday).toISOString().slice(0, 10) + "T08:00";
            document.getElementById("serviceType").value = "";
          }

          this.send = false;
        })
        .catch(() => (this.send = false));
    },
    geo() {
      var self = this;
      this.$gmapApiPromiseLazy()
        .then(() => {
          // eslint-disable-next-line no-undef
          var geocoder = new google.maps.Geocoder();
          var endereco =
            self.job.logradouro +
            " " +
            self.job.numero +
            " " +
            self.job.bairro +
            " " +
            self.job.cidade +
            " " +
            self.job.estado;

          geocoder.geocode({ address: endereco }, function (results, status) {
            // eslint-disable-next-line no-undef
            if (status == google.maps.GeocoderStatus.OK && results) {
              self.job.latitude = results[0].geometry.location.lat();
              self.job.longitude = results[0].geometry.location.lng();
              self.createJob();
            } else {
              geocoder.geocode(
                {
                  region: "pt-BR",
                  componentRestrictions: {
                    postalCode: "" + self.job.cep,
                  },
                },
                function (results2, status2) {
                  // eslint-disable-next-line no-undef
                  if (status2 == google.maps.GeocoderStatus.OK && results2) {
                    self.job.latitude = results2[0].geometry.location.lat();
                    self.job.longitude = results2[0].geometry.location.lng();
                    self.createJob();
                  } else {
                    self.SET_STATUS({
                      text: "Coordenadas de endereço inválidas.",
                      color: "red",
                    });
                    self.send = false;
                  }
                }
              );
            }
          });
        })
        .catch((e) => {
          console.error("[Job] Falha no Google Maps ao gravar o Job (NewJob):", e);
          self.SET_STATUS({
            text: "Você parece estar sem conexão.",
            color: "red",
          });
          self.send = false;
        });
    },
  },
  computed: {
    ...mapGetters("user", ["user", "perfil"]),
  },
  mounted() {
    this.LOAD_PERFIL();
    this.$parent.$parent.$children[0].changeMenu("newJob");
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.newJOB
  div, diary
    margin-bottom: 30px
</style>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.newJOB {
  padding: 32px 35px;
  box-shadow: $shadow;
  background: $white;
  border-radius: 23px;
  color: $font-color;

  div {
    padding: 0px 5px;
  }

  .textarea {
    background: $white !important;
  }

  .title {
    font-size: 34px;
    font-weight: 400;
    margin-bottom: 55px;

    @media (max-width: $large) {
      padding-bottom: 15px;
    }

    strong {
      color: $supporter-1;
    }
  }

  .sla {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 30px;
  }

  .data {
    margin-bottom: 50px;
  }

  .label {
    color: $gray-6;
    font-size: 15px;
    font-weight: 300;

    strong {
      color: $gray-7;
      text-transform: capitalize;
    }
  }

  .save {
    font-size: 16px;
  }

  .buttons-2 {
    padding-top: 35px;

    @media (max-width: $small) {
      margin-top: 27px;
      margin-bottom: 10px;

      button {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
